import { Gtm, gtm } from 'tracking/gtm';
import { PetContextValues } from 'contexts/pet';
import { Segmentation } from 'constants/segmentation';

// TODO: trackFilterOptions seems not being used anymore
/** Wrapper for filter tracking  */
export const trackFilterOptions = ({
  filterType,
  tag,
}: {
  /** eg. sorts */
  filterType: string;
  /** eg. huhn */
  tag: string;
}): void => {
  gtm({
    group: Gtm.GroupName.Collection,
    name: Gtm.CollectionEventName.FilterOptionsClick,
    data: {
      label: `${filterType}-${tag}`,
    },
  });
};

type ShowPetProfileSelectorArgs = {
  showPetSelector: boolean | Segmentation | undefined;
  featureFlag: boolean;
  current: Exclude<PetContextValues, false>;
  isCatProfileEnabled: boolean;
  hasPetProfile: boolean;
};

/**
 * Defines whether we need to show PetProfileSelector or not
 */
export const showPetProfileSelector = ({
  showPetSelector,
  featureFlag,
  current,
  isCatProfileEnabled,
  hasPetProfile,
}: ShowPetProfileSelectorArgs): boolean => {
  const base = Boolean(showPetSelector) && featureFlag;

  // apply changes only for cats for the test variant of 8112
  if (current === 'cats') {
    return isCatProfileEnabled ? hasPetProfile && base : false;
  }

  return base;
};
